import PersonSchema from 'src/lib/paths/person_FULL_Paths.json';
import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';
let P = PersonSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const PersonalDataValidator = new Schema({
	[P.Personenbezogene_Daten_Anrede.path]: {
		type: String,
	},
	[P.Personenbezogene_Daten_Titel.path]: {
		type: String,
	},
	[P.Personenbezogene_Daten_Vorname.path]: {
		type: String,
		required: true,
	},
	[P.Personenbezogene_Daten_Nachname.path]: {
		type: String,
		required: true,
	},
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Fax.path]: {
		type: String,
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
});

PersonalDataValidator.message({
	required: (_path: string) => 'Pflichtfeld.',
	type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
});

export default PersonalDataValidator;
